import {
  IMeasureFieldsFragment,
  IMeasurePropertiesFieldsFragment,
} from '../../apollo/graphqlSchema';
import { IBuilder, RowType } from '../../../redux/slices/oldBuilder';
import { parseMeasureFormula, parseSimpleMeasure } from './utils';
import { assertCondition } from '../../types';
import { UnreachableCaseError } from 'ts-essentials';

/**
 * A function will parse expressions Simple or Compound measure and
 * measureProperties to builder
 */
export const parseExpressionMeasureToBuilder = (
  measure: IMeasureFieldsFragment,
  measureProperties: IMeasurePropertiesFieldsFragment,
): Pick<IBuilder, RowType.measures | 'resultFilter' | 'measureFormula'> => {
  if (measure.__typename === 'SimpleMeasure') {
    assertCondition(measureProperties.__typename === 'SimpleMeasureProperties');

    const { formula } = measure;

    return {
      [RowType.measures]: [parseSimpleMeasure(measure, measureProperties)],
      resultFilter: null,
      measureFormula: parseMeasureFormula(formula),
    };
  } else if (measure.__typename === 'CompoundMeasure') {
    assertCondition(
      measureProperties.__typename === 'CompoundMeasureProperties',
    );

    const { measures, formula } = measure;

    return {
      [RowType.measures]: measures.map((measure, index) =>
        parseSimpleMeasure(
          measure,
          measureProperties.measures?.[index] ?? null,
        ),
      ),
      resultFilter: measureProperties.resultFilter,
      measureFormula: parseMeasureFormula(formula),
    };
  } else {
    throw new UnreachableCaseError(measure);
  }
};
